export default __webpack_public_path__ + "static/media/26_gallery.0a97e0f2.jpg";